import { produce } from 'immer';
import { notification } from 'antd';
import { fetchReportPageShoplog } from '@/services/api';

export default {
  namespace: 'specialBusinessTime',

  state: {
    type: 'manual', // 上传方式：manual 手动上传，excel 方式上传
    shopIdType: 'dp', // mt dp
    templateType: 'BatchM', // 修改模板类型：BatchM 批量修改，SingleM 单独修改（手动录入模式下默认为BatchM）
    fileList: [], // excel方式上传时的文件地址
    selectedShops: [],
    specialBusinessTimes: [],
    submitLog: {
      currentPage: 0,
      pageSize: 10,
      totalItems: 0,
      totalPage: 0,
      hasNext: false,
      data: [],
    },
  },

  reducers: {
    updateSubmitLog(state, action) {
      const { payload } = action;
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft.submitLog[key] = payload[key];
        });
      });
    },
    selectShop(state, action) {
      const { payload } = action;
      return produce(state, draft => {
        draft.selectedShops = payload;
      });
    },
    updateSpecialBusinessTime(state, action) {
      const { payload } = action;
      return produce(state, draft => {
        draft.specialBusinessTimes = payload;
      });
    },
    updateFields(state, { payload }) {
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft[key] = payload[key];
        });
      });
    },
  },

  effects: {
    *fetchReportPageShoplog({ payload }, { select, call, put }) {
      const { pageSize } = yield select(state => state.specialBusinessTime.submitLog);
      const data = yield call(
        fetchReportPageShoplog,
        { currentPage: payload, pageSize },
        ({ msg = '' }) => {
          notification.error({
            message: '网络请求失败',
            description: msg,
            duration: 0,
          });
        }
      );
      yield put({
        type: 'updateSubmitLog',
        payload: data,
      });
    },
  },
};
